/** Number display for the Sales Recap: whole units, $ for dollars, a true minus sign. */

const whole = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

export function amount(value: number, money: boolean): string {
  const shown = whole.format(Math.abs(Math.round(value)))
  const sign = Math.round(value) < 0 ? '−' : ''
  return money ? `${sign}$${shown}` : `${sign}${shown}`
}

export function percent(value: number | null): string {
  if (value === null) return '—'
  return `${value < 0 ? '−' : ''}${Math.abs(value).toFixed(1)}%`
}

export function tone(value: number): string {
  if (Math.round(value) === 0) return ''
  return value < 0 ? 'srp-under' : 'srp-over'
}
